"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const PlayerGrid_1 = tslib_1.__importDefault(require("../../../ui-lib/PlayerGrid"));
const PlayersGridWrapper = (0, mobx_react_lite_1.observer)(({ classes, children }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamPlayersGridWrapper/>");
    // const render = useGridRerender();
    const { playersWrapperElement } = ctx;
    return (react_1.default.createElement(PlayerGrid_1.default, { ref: playersWrapperElement, classes: classes }, children));
});
/**
 *
 * @visibleName Players Grid
 */
// eslint-disable-next-line react/function-component-definition
const PlayersGridWrapperWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(PlayerGrid_1.default, { classes: classes, ...props }) },
        react_1.default.createElement(PlayersGridWrapper, { classes: classes, ...props })));
};
exports.default = PlayersGridWrapperWithErrorBoundary;
//# sourceMappingURL=PlayerGridWrapper.js.map